import React, { useState } from 'react';

import Home from './pages/home';
import Detail from './pages/detail';

const App = () => {
  const [hash, setHash] = useState(window.location.hash);

  window.onhashchange = e => {
    setHash(window.location.hash);
  };
  return hash === '#detail' ? <Detail /> : <Home />;
};

export default App;
